<template>
  <div class='main'>
    <div class="main_left_box1_top">
      <div>
        <el-cascader
          :options="classList"
          v-model="experParams.classid"
          @change="GetExperSumData"
          placeholder="请选择班级"
          clearable
          :props="{ expandTrigger: 'hover',label:'orgname',value:'orgid',emitPath:false }"
          :show-all-levels="false"
        ></el-cascader>
        <el-cascader
          style="margin-left:10px"
          :options="experTreeList"
          v-model="experParams.experimentid"
          @change="GetExperSumData"
          placeholder="请选择实验"
          clearable
          :props="{ expandTrigger: 'hover',label:'itemname',value:'itemid',emitPath:false }"
          :show-all-levels="false"
        ></el-cascader>
      </div>
      <div class="sum">
        <div>总次数：<span>{{theoryRandTableData.allcount}}</span></div>
        <div>总人次：<span>{{theoryRandTableData.usercount}}</span></div>
        <div>成功率：<span>{{theoryRandTableData.successrate}}</span></div>
      </div>
    </div>
    <div class="main_left_box1_body">
      <el-table
        :data="theoryRandTableData.list"
        stripe
        empty-text="请选择班级和实验"
        style="width: 100%"
      >
        <el-table-column
          type="index"
          label="序号"
          width="80"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="username"
          label="学生姓名"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="usercode"
          label="学号"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="classname"
          label="班级名称"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="count"
          label="操作次数"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="maxtime"
          label="最高时长"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="mintime"
          label="最低时长"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="avgtime"
          label="平均时长"
          align="center"
        >
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import Api from '../../api/index'

export default {
  data () {
    return {
      classList: [],
      experTreeList: [],
      experParams: {
        experimentid: '',
        classid: '',
      },
      theoryRandTableData: [],
    }
  },
  created () {
    this.GetOrgDataTree()
    this.GetExperTree()
    this.GetExperSumData()
  },
  methods: {
    //获取系室专业班级树形图
    async GetOrgDataTree () {
      const res = await Api.organization.GetOrgDataTree()
      this.classList = res.rows
    },
    //获取实验树形结构
    async GetExperTree () {
      const res = await Api.sum.GetExperTree()
      this.experTreeList = res.rows
    },
    //实验统计数据
    async GetExperSumData () {
      this.GetExperTree()
      this.GetOrgDataTree()
      const res = await Api.sum.GetExperSumData(this.experParams)
      this.theoryRandTableData = res.rows
      this.theoryRandTableData.successrate = Math.round(this.theoryRandTableData.successrate * 100) + '%'
    },
  }
}
</script>
<style lang='less' scoped>
.main {
  width: 100%;
  height: 100%;
  background: #fff;
  .main_left_box1_top {
    display: flex;
    justify-content: space-between;
    padding: 15px 25px 15px 25px;

    .sum {
      display: flex;
      > div {
        margin-right: 20px;
        font-size: 15px;
        font-weight: 600;
        > span {
          color: coral;
        }
      }
    }
  }
}
</style>